import { useEffect, useState } from "react";
import { CheckCircle2, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useApp } from "@/context/AppContext";
import { useFetch } from "@/hooks/useFetch";
import { spaceParams } from "@/lib/spaces";
import { Empty, Loading, PageHeader } from "@/components/Bits";
import { ReminderItem } from "@/components/ReminderItem";

export default function Completed() {
  const { space } = useApp();
  const [text, setText] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    const t = setTimeout(() => setSearch(text.trim()), 300);
    return () => clearTimeout(t);
  }, [text]);

  const items = useFetch("/reminders", { ...spaceParams(space), status: "done", ...(search ? { search } : {}) });

  return (
    <div data-testid="completed-page">
      <PageHeader title="Completed" subtitle="Every reminder that's been ticked off. Search titles, details and updates. Click one to see its full history." />
      <div className="relative mb-6 max-w-xl">
        <Search className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input value={text} onChange={(e) => setText(e.target.value)} placeholder="Search completed reminders…" className="h-12 rounded-full pl-11 text-base" data-testid="completed-search-input" />
      </div>
      {!items ? <Loading /> : items.length === 0 ? (
        <Empty icon={CheckCircle2} text={search ? `Nothing completed matches "${search}".` : "Nothing completed yet."} testid="empty-completed" />
      ) : (
        <>
          <p className="mb-3 text-xs text-muted-foreground" data-testid="completed-count">{items.length} completed{search ? ` matching "${search}"` : ""}</p>
          <div className="max-w-4xl space-y-3">{items.map((r) => <ReminderItem key={r.id} r={r} />)}</div>
        </>
      )}
    </div>
  );
}
